import { useState } from "react";
import { motion } from "framer-motion";
import { Users, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { savePlayerNames, loadPlayerNames } from "@/utils/playerStorage";

const PLAYER_COLORS = ["#06b6d4", "#ec4899", "#a855f7", "#eab308"];

export const PlayerNamesDialog = ({ isOpen, onSubmit, onClose, playerCount = 2 }) => {
  const [names, setNames] = useState(() => loadPlayerNames());

  const updateName = (idx, val) => {
    const n = [...names];
    n[idx] = val;
    setNames(n);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const filled = names.slice(0, playerCount).map((n, i) => n.trim() || `Pemain ${i + 1}`);
    savePlayerNames(names);
    onSubmit(filled[0], filled[1] || "Pemain 2", filled);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="glass-card-strong border-gold/20 max-w-sm rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-fredoka text-2xl text-white flex items-center gap-2">
            <Users className="w-6 h-6" />
            Nama Pemain
          </DialogTitle>
          <DialogDescription className="font-fredoka text-gold-light/80">
            Masukkan nama {playerCount} pemain!
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-3 mt-4">
          {Array.from({ length: playerCount }).map((_, i) => (
            <div key={i}>
              <label className="font-fredoka text-sm mb-1 block font-bold" style={{ color: PLAYER_COLORS[i] }}>
                Pemain {i + 1}
              </label>
              <Input
                data-testid={`player-name-input-${i}`}
                type="text"
                placeholder={`Pemain ${i + 1}`}
                value={names[i]}
                onChange={(e) => updateName(i, e.target.value)}
                maxLength={15}
                className="glass-card border-gold/20 font-fredoka text-white placeholder:text-gold-light/40 focus:ring-gold/30 focus:border-gold/40 rounded-xl"
                autoFocus={i === 0}
              />
            </div>
          ))}

          <div className="flex gap-2 pt-1">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 glass-card border-gold/20 text-gold-light/80 hover:bg-gold/10 font-fredoka rounded-xl"
            >
              Batal
            </Button>
            <Button
              data-testid="start-pvp-button"
              type="submit"
              className="flex-1 bg-gradient-to-r from-pink-500 to-rose-500 text-gold-light hover:opacity-90 font-fredoka font-bold rounded-xl shadow-lg"
            >
              <Play className="w-4 h-4 mr-2" />
              Mulai!
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PlayerNamesDialog;
